import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteProcess } from '../../../../actions';

const ProcessDeleteButton = ({
  dispatchDeleteProcess,
  processId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteProcess({ processId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ProcessDeleteButton.propTypes = {
  dispatchDeleteProcess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  processId: PropTypes.number.isRequired,
};

ProcessDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteProcess: deleteProcess,
};

export default connect(null, mapDispatchToProps)(ProcessDeleteButton);
